import Konva from "konva";
import store from "../../../store/store";
import { DMCScrolling } from "../KObjects/DMCScrolling";

export class Scrolling {
  constructor() {
    this.layer = {};
    this.currentObject = null;
    this.currentShapeConfig = {};
    this.interval = false;
    this.origin = {};
    this.currentController = [];
    this.name = "Scrolling";
    (this.type = "widget"),
      (this.currentOptions = {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        scaleX: 0,
        scaleY: 0,
      });
    this.dataScrolling = [];
  }

  scrolling(dataScrolling, name) {
    this.name = name;
    this.dataScrolling = dataScrolling;
  }

  createControllerObject(name, konvaObject) {
    return new DMCScrolling(name, konvaObject, this.dataScrolling);
  }

  createNew(controllerProject, incorporate = true) {
    this.currentController = controllerProject;

    const rect = new Konva.Rect({ name: "rectScrolling" });
    if (this.dataScrolling.axe) {
      if (!this.dataScrolling.sens) {
        this.currentObject = this.scrollingHorizontal(rect, controllerProject);
      } else {
        this.currentObject = this.scrollingHorizontalReverse(rect, controllerProject);
      }
    } else {
      if (!this.dataScrolling.sens) {
        this.currentObject = this.scrollingVertical(rect, controllerProject);
      } else {
        this.currentObject = this.scrollingVerticalReverse(rect, controllerProject);
      }
    }
    if (incorporate) {
      this.layer = controllerProject.addElementToCurrentLayerReturn(this.currentObject);
    }
  }

  loadSpec(controllerProject, DMCObject, incorporate) {
    if (this.dataScrolling.urlFeed !== undefined) {
      generatedRSS(this.dataScrolling, DMCObject.name);
      const text = localStorage["text" + DMCObject.name.toUpperCase()];
      if (text !== undefined) {
        this.dataScrolling.text = text;
      }
    }
    this.createNew(controllerProject, incorporate);
    this.currentObject.setAttr("x", DMCObject.konvaObjectOption.x);
    this.currentObject.setAttr("y", DMCObject.konvaObjectOption.y);
    this.currentObject.setAttr("width", DMCObject.konvaObjectOption.width);
    this.currentObject.setAttr("height", DMCObject.konvaObjectOption.height);
    this.currentObject.id(DMCObject.konvaObjectOption.id);
    this.updateCurrentOptions(
      this.currentObject.getAttr("x"),
      this.currentObject.getAttr("y"),
      this.currentObject.getAttr("width"),
      this.currentObject.getAttr("height")
    );

    if (incorporate) {
      this.layer = controllerProject.addElementToCurrentLayerReturn(this.currentObject);
    }
    return this.currentObject;
  }

  mouseUp(controllerProject) {
    this.singleClickPrevent();
    clearInterval(this.interval);
    this.interval = false;
    controllerProject.destroyAllTransformer();
    controllerProject.currentSelection = this.createTransformer(this.currentObject);

    controllerProject.addElementToCurrentLayer(controllerProject.currentSelection);
    const name = controllerProject.addNewObjectToCurrentLayer(this.currentObject, this.name, this);

    try {
      controllerProject.stage.draw();
    } catch (err) {
      console.error(err);
    }

    this.currentOptions = this.resetOptions();

    return name;
  }

  mouseDown(controllerProject) {
    this.dataScrolling.scale = controllerProject.scale;
    this.currentController = controllerProject;
    this.createNew(controllerProject);
    if (!this.interval) {
      this.interval = setInterval(() => {
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        let width = this.currentObject.children[0].attrs.width;
        let height = this.currentObject.children[0].attrs.height;

        if (this.dataScrolling.axe) {
          this.currentObject.setAttr("x", 0);
          this.currentObject.setAttr("y", Math.round(currentMousePos.y / controllerProject.scale));
          width = controllerProject.projectSize.width;
        } else {
          this.currentObject.setAttr("x", Math.round(currentMousePos.x / controllerProject.scale));
          this.currentObject.setAttr("y", 0);
          height = controllerProject.projectSize.height;
        }
        this.currentObject.setAttr("width", width);
        this.currentObject.setAttr("height", height);
        this.currentObject.setAttr("fontSize", this.dataScrolling.size);

        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 30);
    }
  }

  createTransformer(elementToTransform) {
    return new Konva.Transformer({
      resizeEnabled: false,
      rotateEnabled: false,
      isTransforming: false,
      node: elementToTransform,
      keepRatio: true,
      enabledAnchors: [
        "top-left",
        "top-center",
        "top-right",
        "middle-right",
        "middle-left",
        "bottom-center",
        "bottom-left",
        "bottom-right",
      ],
    });
  }
  updateCurrentOptions(x, y, width, height) {
    this.currentOptions.x = x;
    this.currentOptions.y = y;
    this.currentOptions.width = width;
    this.currentOptions.height = height;
  }
  resetOptions() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      scaleX: 0,
      scaleY: 0,
    };
  }
  singleClickPrevent() {
    if (this.currentObject.attrs.width == 0) {
      this.currentObject.setAttr("width", 1);
    }
    if (this.currentObject.attrs.height == 0) {
      this.currentObject.setAttr("height", 1);
    }
  }
  scrollingHorizontal(rect, controllerProject) {
    let simpleText = this.simpleText();
    let simpleText2 = this.simpleText();

    rect.width(this.currentController.projectSize.width);
    rect.height(simpleText.size().height);

    let group = new Konva.Group({
      scaleX: 1,
      scaleY: 1,
      draggable: true,
      dragBoundFunc: function (pos) {
        controllerProject.stage.container().style.cursor = "grabbing";

        return {
          x: this.absolutePosition().x,
          y: pos.y,
        };
      },
    });

    simpleText.x(this.currentController.projectSize.width - simpleText.size().width);
    simpleText2.x(this.currentController.projectSize.width - simpleText.size().width);
    group.add(rect, simpleText, simpleText2);

    return group;
  }
  scrollingVertical(rect, controllerProject) {
    let simpleText = this.simpleText();
    let simpleText2 = this.simpleText();

    rect.width(simpleText.size().width);
    rect.height(this.currentController.projectSize.height);

    let group = new Konva.Group({
      scaleX: 1,
      scaleY: 1,
      draggable: true,
      dragBoundFunc: function (pos) {
        controllerProject.stage.container().style.cursor = "move";
        return {
          x: pos.x,
          y: this.absolutePosition().y,
        };
      },
    });

    simpleText.y(this.currentController.projectSize.height - simpleText.size().height);
    simpleText2.y(this.currentController.projectSize.height - simpleText.size().height);
    group.add(rect, simpleText, simpleText2);

    return group;
  }
  scrollingHorizontalReverse(rect, controllerProject) {
    let simpleText = this.simpleText();
    let simpleText2 = this.simpleText();

    rect.width(this.currentController.projectSize.width);
    rect.height(simpleText.size().height);

    let group = new Konva.Group({
      scaleX: 1,
      scaleY: 1,
      draggable: true,
      dragBoundFunc: function (pos) {
        controllerProject.stage.container().style.cursor = "move";
        return {
          x: this.absolutePosition().x,
          y: pos.y,
        };
      },
    });

    group.add(rect, simpleText, simpleText2);

    return group;
  }
  scrollingVerticalReverse(rect, controllerProject) {
    let simpleText = this.simpleText();
    let simpleText2 = this.simpleText();

    rect.width(simpleText.size().width);
    rect.height(this.currentController.projectSize.height);

    let group = new Konva.Group({
      scaleX: 1,
      scaleY: 1,
      draggable: true,
      dragBoundFunc: function (pos) {
        controllerProject.stage.container().style.cursor = "move";
        return {
          x: pos.x,
          y: this.absolutePosition().y,
        };
      },
    });

    group.add(rect, simpleText, simpleText2);

    return group;
  }
  simpleText() {
    const simpleText = new Konva.Text({
      name: "textScrolling",
      x: 0,
      y: 0,
      text: this.dataScrolling.text,
      fontSize: this.dataScrolling.size,
      fontFamily: this.dataScrolling.font,
      fill: this.dataScrolling.color,
      align: this.dataScrolling.align,
    });

    return simpleText;
  }

  setContent(dataScrolling, name) {
    this.scrolling(dataScrolling, name);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject);
    this.currentObject.setAttr("x", this.edit.x);
    this.currentObject.setAttr("y", this.edit.y);
    this.currentObject.setAttr("width", this.edit.width);
    this.currentObject.setAttr("height", this.edit.height);
    this.currentObject.setAttr("scaleX", this.edit.scaleX);
    this.currentObject.setAttr("scaleY", this.edit.scaleY);
    this.edit = "";
    return this.mouseUp(controllerProject);
  }
}

function generatedRSS(dataScrolling, id) {
  let separator = "  ";
  let feed = "";
  let text = "";

  if (!store.state.config.system.isCreation) {
    const rssParser = require("rss-parser");
    const parser = new rssParser();

    parser.parseURL(dataScrolling.urlFeed).then((datas) => {
      feed = datas;

      if (!dataScrolling.axe) {
        separator = "\r\n";
      }

      for (let j = 1; j < dataScrolling.entraxe; j++) {
        if (dataScrolling.axe) {
          separator = separator.concat("    ");
        } else {
          separator = separator.concat("\r\n");
        }
      }

      for (let i = 0; i < dataScrolling.countRss; i++) {
        if (i == 0) {
          text = feed.items[i].title;
        } else {
          text = text.concat(separator, feed.items[i].title);
        }
      }

      localStorage["date" + id.toUpperCase()] = Date.now();
      localStorage["text" + id.toUpperCase()] = text;
    });
  }
}
